import { callApi } from '@local_modules/generic/fetch'
import { fillString } from '@local_modules/generic/string-template'

export async function associateEntity (appAccountId, xeroEntityId) {
  const urlEndpoint = '/api/app-account-organisation/:appAccountId/:xeroEntityId/associate'

  const url = fillString(urlEndpoint, {
    appAccountId,
    xeroEntityId
  })

  const response = await callApi(url, null, {
    method: 'POST'
  })

  return response
}
